import { useState } from "react";
import { submitVcVote } from "../lib/api.js";

interface VcVoteState {
  loading: boolean;
  error: string | null;
  result: any | null;
  voted: boolean;
}

export function useVcVote() {
  const [state, setState] = useState<VcVoteState>({
    loading: false,
    error: null,
    result: null,
    voted: false,
  });

  async function vote(data: {
    vc_id: string;
    vibe: number;
    horizon_bucket?: number | null;
    reason_tag?: string | null;
    turnstile_token: string;
  }) {
    setState({ loading: true, error: null, result: null, voted: false });

    try {
      const result = await submitVcVote(data);
      setState({ loading: false, error: null, result, voted: true });
      return result;
    } catch (err: any) {
      setState({
        loading: false,
        error: err.message,
        result: null,
        voted: false,
      });
      throw err;
    }
  }

  function reset() {
    setState({ loading: false, error: null, result: null, voted: false });
  }

  return { ...state, vote, reset };
}
